import { render, staticRenderFns } from "./BannerMediaCreateAndUpdateFormItems.vue?vue&type=template&id=72090010&"
import script from "./BannerMediaCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./BannerMediaCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72090010')) {
      api.createRecord('72090010', component.options)
    } else {
      api.reload('72090010', component.options)
    }
    module.hot.accept("./BannerMediaCreateAndUpdateFormItems.vue?vue&type=template&id=72090010&", function () {
      api.rerender('72090010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BannerMediaCreateAndUpdateFormItems.vue"
export default component.exports